import { Subject, BehaviorSubject } from 'rxjs';

/**
 * Base state class with RxJS subjects for reactive state management
 */
export abstract class BaseState {
  protected stateChanged$ = new Subject<any>();

  constructor() {
    // Initialize state
  }

  /**
   * Get state changed observable
   */
  get stateChanged() {
    return this.stateChanged$.asObservable();
  }

  /**
   * Emit state change
   */
  protected emitStateChange(data?: any): void {
    this.stateChanged$.next(data);
  }

  /**
   * Get current state as a plain object
   */
  abstract getState(): Record<string, any>;

  /**
   * Update state with partial updates
   */
  abstract updateState(updates: Record<string, any>): void;
}
